/**
 * Implement Gatsby's SSR (Server Side Rendering) APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/ssr-apis/
 */

/* eslint-disable import/prefer-default-export */
/* eslint react/prop-types: 0 */

import React from "react";
import "./src/css/index.css";
import wrapWithState from "@state/wrapWithState";

export const wrapRootElement = wrapWithState;

export const wrapPageElement = ({ element, props }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{element}</>;
};
